import { Shield, Truck, Award, FileCheck, Users } from "lucide-react";

const BADGES = [
  { icon: FileCheck, title: "GST Registered", sub: "GSTIN Verified" },
  { icon: Shield, title: "100% Insured", sub: "Transit + Damage Cover" },
  { icon: Award, title: "15+ Years", sub: "Trusted in Delhi NCR" },
  { icon: Truck, title: "25+ Own Trucks", sub: "Dedicated Fleet" },
  { icon: Users, title: "50,000+ Happy Families", sub: "Since 2010" },
];

export default function TrustBadges() {
  return (
    <section className="bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid grid-cols-2 md:grid-cols-5 gap-6" data-testid="trust-badges">
        {BADGES.map((b) => (
          <div key={b.title} className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-orange-50 grid place-items-center text-[#F97316]">
              <b.icon className="w-5 h-5" />
            </div>
            <div>
              <div className="font-semibold text-sm text-[#0F172A]">{b.title}</div>
              <div className="text-xs text-slate-500">{b.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
